/**
 * Interruptor de lo que pasa por la API de Claude.
 *
 * Apagado el 7 de septiembre de 2026 a peticion del usuario. El recap
 * ("¿Por donde ibas?") y Zangetsu son lo unico de la app que cuesta dinero
 * —se factura a la cuenta de la API, que no es el plan— y se quedan fuera
 * hasta nuevo aviso.
 *
 * No se ha borrado nada: ni los componentes, ni sus clientes, ni las tablas
 * del servidor con lo que ya estaba resumido. Ponerlo en `true` y volver a
 * compilar los devuelve tal y como estaban.
 *
 * El otro lado del interruptor esta en `servidor/recap.py` (`IA_ACTIVA`), y
 * ese es el que de verdad impide el gasto: el iPhone puede seguir sirviendo
 * la version anterior de la app desde su cache un buen rato, con los botones
 * todavia puestos, y ahi lo unico que para la llamada es el servidor.
 *
 * Lo que NO depende de esto es la traduccion de bocadillos del lector: la
 * hace Tesseract en el VPS y no cuesta nada, asi que sigue funcionando.
 */
export const IA_ACTIVA = false
